import * as React from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Button from '@mui/material/Button';
import {CircularProgress, makeStyles} from "@material-ui/core";
import BasicMenu from "./DropdownMenu";
import {Chip} from "@mui/material";
import { useNavigate } from "react-router-dom";

const steps = [
    'Category', 'Course', 'Level'];
const menuOptions = [
    ['College Preps', 'Cambridge', 'Skillhub', 'Necta', 'IB'],
    ['Mathematics', 'Cooking', 'Economics', 'Computer', 'Language'],
    ['Beginner', 'Intermediate', 'Advanced']
]

export default function HorizontalLinearStepper({style}) {
    let navigate = useNavigate();
    const [activeStep, setActiveStep] = React.useState(0);
    const [skipped, setSkipped] = React.useState(new Set());

    const isStepSkipped = (step) => {
        return skipped.has(step);
    };

    const handleNext = () => {
        let newSkipped = skipped;
        if (isStepSkipped(activeStep)) {
            newSkipped = new Set(newSkipped.values());
            newSkipped.delete(activeStep);
        }

        setActiveStep((prevActiveStep) => prevActiveStep + 1);
        setSkipped(newSkipped);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleReset = () => {
        setActiveStep(0);
    };

  if (activeStep === steps.length) {
      setTimeout(() => {
          console.log('navigating to tutors cards, to mimic the fetching!')
          navigate('/tutors')
      }, 3000);
  }

    const useStyles = makeStyles(() => ({
        root: {
            '& .MuiStepIcon-root': {fontSize: 32},
            '& .MuiStepIcon-text': {fontSize: 12},
            '& .MuiStepIcon-root.Mui-active': {color: '#DE5103'},
            '& .MuiStepIcon-root.Mui-completed': {color: '#DE5103'},
            '& .MuiStepLabel-label': {fontSize: 14},
        }
    }))

    const useStyleObject = useStyles();
    return (
        <Box>
            <Box sx={{width: '100%',display: {xs: 'none',sm: 'block', md: 'block', lg: 'block'}}} style={style}>
                <Stepper activeStep={activeStep} className={useStyleObject.root} >
                    {steps.map((label) => {
                        const stepProps = {};
                        const labelProps = {};
                        return (
                            <Step key={label} {...stepProps} >
                                <StepLabel {...labelProps} active={{color: 'orange'}}>{label}</StepLabel>
                            </Step>
                        );
                    })}
                </Stepper>
                {activeStep === steps.length ? (
                    <React.Fragment>
                        <Box sx={{display: 'flex', flexDirection: 'row', pt: 2}}>
                            <Box sx={{flex: '1 1 auto'}}/>
                            <Button onClick={handleReset}>Reset</Button>
                            <CircularProgress />
                        </Box>
                    </React.Fragment>
                ) : (
                    <React.Fragment>
                        {/*<Typography sx={{mt: 2, mb: 1}}>Step {activeStep + 1}</Typography>*/}
                        <Box sx={{display: 'flex', flexDirection: 'row', pt: 1, alignItems: 'center'}}>
                            {activeStep === 0 ?
                                <Box sx={{ml: 6, width: '20%'}}>
                                    <BasicMenu placeholder={steps[0]} onClick={handleNext} customWidth={'9.5%'}
                                               menuOption={menuOptions[0[0]]}/>
                                </Box> :
                                <Chip label='choice one selected'
                                      sx={{ml: 6, backgroundColor: '#DE5103', color: "white", fontSize: 12}}/>
                            }
                            {activeStep === 1 ?
                                <Box sx={{ml: 22, width: '18%'}}>
                                    <BasicMenu placeholder={steps[1]} onClick={handleNext}  customWidth={ '8.7%'}/>
                                </Box> : null
                                // <Chip label='choice two selected'
                                //                sx={{ml: 15, backgroundColor: '#DE5103', color: "white", fontSize: 12}}/>
                            }
                            {activeStep === 2 ?

                                <Box sx={{display: 'flex', flexDirection: 'row', justifyContent: "flex-end"}}>
                                    <Chip label='choice two selected'
                                          sx={{ml: 20, backgroundColor: '#DE5103', color: "white", fontSize: 12}}/>
                                    <Box sx={{ width: '20%', ml: 18}}>
                                        <BasicMenu placeholder={steps[2]} onClick={handleNext}  customWidth={ '7.5%'}/>
                                    </Box>
                                </Box>
                                : null
                            }
                        </Box>
                        <Box sx={{display: 'flex', flexDirection: 'row', pt: 2}}>
                            <Box sx={{flex: '1 1 auto'}}/>
                            {
                                activeStep === 0 ? null :
                                    <Button onClick={handleBack}  variant='contained' style={{ backgroundColor: '#DE5103'}}>
                                        Back
                                    </Button>
                            }
                        </Box>
                    </React.Fragment>
                )}
            </Box>


        </Box>
    );
}
